import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="desktop ipad-portrait-show">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport ilead_v_sport_new_task tablesrink mutitable2">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" align="center" valign="center"
                                                            className="green_curve ">Primary Preference
                                                        </th>
                                                        <th width="20%" align="left" valign="center">Secondary
                                                            Preference
                                                        </th>
                                                        <th width="60%" align="left" valign="top"
                                                            className=" green_curve1"></th>


                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="center" valign="center"
                                                            className="lightgreen" rowSpan="3"><p
                                                            className="subtiltereg ">Logical facts </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen"><p>The art of
                                                            persuasion</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>Your approach is based on
                                                            logic, facts and persuading people
                                                            to ‘see the sense’ of your plan.

                                                        </p><br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                rely too heavily on factual data and you will
                                                                need
                                                                to be certain of your information’s accuracy.
                                                            </p></div>
                                                        </td>


                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">Sell the benefits
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p>You probably outline the
                                                            rationale for your idea and then focus
                                                            on its potential benefits to forestall
                                                            challenges.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> If
                                                                people don’t respond to this approach, you
                                                                may lack
                                                                another means of persuading them.</p></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen">Negotiate the deal
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>You may simply present the
                                                            facts, figures and a general explanation
                                                            – then open a discussion about how someone could get
                                                            involved.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> Your
                                                                idea may not appeal if you haven’t taken the
                                                                time to
                                                                describe and ‘sell’ the overall idea more
                                                                imaginatively.</p></div>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Logical facts </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>The art of persuasion</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>Your approach is based on logic, facts and
                                                                persuading people
                                                                to ‘see the sense’ of your plan.

                                                            </p><br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                rely too heavily on factual data and you will
                                                                need
                                                                to be certain of your information’s accuracy.
                                                            </p></div>
                                                        </td>


                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Logical facts</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top" className="darkgreen">

                                                            <p>Sell the benefits</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-right">
                                                            <p>You probably outline the rationale for your idea
                                                                and then focus
                                                                on its potential benefits to forestall
                                                                challenges.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> If
                                                                people don’t respond to this approach, you
                                                                may lack
                                                                another means of persuading them.</p></div>
                                                        </td>

                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Logical facts</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>Negotiate the deal </p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>You may simply present the facts, figures and a
                                                                general explanation
                                                                – then open a discussion about how someone could
                                                                get involved.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> Your
                                                                idea may not appeal if you haven’t taken the
                                                                time to
                                                                describe and ‘sell’ the overall idea more
                                                                imaginatively.</p></div>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="desktop ipad-portrait-show">

                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport ilead_v_sport_new_task tablesrink mutitable2">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" align="center" valign="center"
                                                            className="green_curve ">Primary Preference
                                                        </th>
                                                        <th width="20%" align="center" valign="center">Secondary
                                                            Preference
                                                        </th>
                                                        <th width="60%" align="left" valign="top"
                                                            className=" green_curve1"></th>


                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="center" valign="center"
                                                            className="lightgreen" rowSpan="3"><p
                                                            className="subtiltereg ">Sell the benefits</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen"><p>The art of
                                                            persuasion</p></td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>You tend to rely on
                                                            emphasising the opportunities your idea offers
                                                            to persuade people to commit to it.

                                                        </p><br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You might
                                                                be challenged about the plan’s detail and
                                                                your logic.</p></div>
                                                        </td>


                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">Logical facts
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p>You primarily focus on the
                                                            benefits of your idea, supported by
                                                            key facts and figures.</p><br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> If this
                                                                approach doesn’t work first time, you may
                                                                struggle
                                                                to negotiate commitment.</p></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="left"
                                                            className="lightgreen">Negotiate the deal
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>You probably outline your
                                                            plan’s real or potential benefits, then
                                                            ask how or when people can schedule their
                                                            contribution.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> Some
                                                                people may not be persuaded without a
                                                                detailed
                                                                explanation of your rationale or your plan’s
                                                                broader relevance.</p></div>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Sell the benefits</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>The art of persuasion</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>You tend to rely on emphasising the opportunities
                                                                your idea offers
                                                                to persuade people to commit to it.

                                                            </p><br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You might
                                                                be challenged about the plan’s detail and
                                                                your logic.</p></div>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Sell the benefits</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top" className="darkgreen">

                                                            <p>Logical facts</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-right">
                                                            <p>You primarily focus on the benefits of your idea,
                                                                supported by
                                                                key facts and figures.</p><br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> If this
                                                                approach doesn’t work first time, you may
                                                                struggle
                                                                to negotiate commitment.</p></div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Sell the benefits</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>Negotiate the deal </p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>You probably outline your plan’s real or
                                                                potential benefits, then
                                                                ask how or when people can schedule their
                                                                contribution.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> Some
                                                                people may not be persuaded without a
                                                                detailed
                                                                explanation of your rationale or your plan’s
                                                                broader relevance.</p></div>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="desktop ipad-portrait-show">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className=" ilead_v_sport_new_task ilead_v_sport tablesrink mutitable2">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" align="center" valign="center"
                                                            className="green_curve commite">Primary Preference
                                                        </th>
                                                        <th width="20%" align="center" valign="center">Secondary
                                                            Preference
                                                        </th>
                                                        <th width="60%" align="left" valign="top"
                                                            className=" green_curve1"></th>


                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="center" valign="center"
                                                            className="lightgreen" rowSpan="3"><p
                                                            className="subtiltereg ">Negotiate the deal</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="center"
                                                            className="lightgreen"><p>The art of
                                                            persuasion</p></td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>You’re likely to
                                                            concentrate on getting some kind of commitment
                                                            and probably use different methods to do so.

                                                        </p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                risk alienating people with this approach by
                                                                appearing to ‘steamroller’ them, especially
                                                                if they need time to
                                                                reflect and consider.</p></div>
                                                        </td>


                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="center"
                                                            className="darkgreen">Logical facts
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p>You’re likely to rely on
                                                            presenting the facts about how your idea
                                                            would work, then push for agreement on that basis
                                                            alone.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                not appeal to people who respond to a more
                                                                intuitive, empathetic or imaginative
                                                                approach.</p></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="left"
                                                            className="lightgreen">Sell the benefits
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>You tend to outline the
                                                            benefits and unique selling points of your
                                                            proposition – then push for a deal.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                risk demonstrating limited consideration for
                                                                potential risks as well as the more positive
                                                                aspects.</p></div>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Negotiate the deal</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>The art of persuasion</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>You’re likely to concentrate on getting some kind
                                                                of commitment
                                                                and probably use different methods to do so.

                                                            </p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                risk alienating people with this approach by
                                                                appearing to ‘steamroller’ them, especially
                                                                if they need time to
                                                                reflect and consider.</p></div>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Negotiate the deal</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top" className="darkgreen">

                                                            <p>Logical facts</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-right">
                                                            <p>You’re likely to rely on presenting the facts
                                                                about how your idea
                                                                would work, then push for agreement on that
                                                                basis alone.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                not appeal to people who respond to a more
                                                                intuitive, empathetic or imaginative
                                                                approach.</p></div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Negotiate the deal</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>Negotiate the deal </p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>You tend to outline the benefits and unique
                                                                selling points of your
                                                                proposition – then push for a deal.</p>
                                                            <br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                risk demonstrating limited consideration for
                                                                potential risks as well as the more positive
                                                                aspects.</p></div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page9')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}